// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1s_ZC","info":"UpdateTermsInfo_info__Gr5yD"};